// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newTagHeader_D4FE5 {
  height: 40px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 6px 18px;
  /* background-color: var(--f5-background); */
  position: sticky;
  top: 0;
  @media (width<=768px) {
    padding: 6px 4px;
  }
  .leftSide_g8nSi {
    display: flex;
    align-items: center;
    gap: 10px;
    .iconContainer_q6rdb {
      border: none;
      outline: none;
      border-radius: 6px;
      -webkit-border-radius: 6px;
      -moz-border-radius: 6px;
      -ms-border-radius: 6px;
      -o-border-radius: 6px;
      cursor: pointer;
      border: 1px solid transparent;
      padding: 4px;
      display: flex;
      background-color: var(--_10a37f-background);
      color: var(--white-color);
      align-items: center;
      justify-content: center;
      height: fit-content;
      box-sizing: border-box;
      height: 25px;
      width: 25px;
      pointer-events: all;
    }
    h3 {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 17px;
      color: var(--black-color);
      text-align: center;
      font-family: Inter;
      font-size: 19px;
      font-style: normal;
      font-weight: 500;
      line-height: 130%; 
      margin: 0px 0;
      @media (width<=768px) {
        font-size: 15px;
        
      }
    }
  }

  .rightSide_LBM3u {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/HeaderCard/HeaderCard.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT;MACE,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,eAAe;MACf,6BAA6B;MAC7B,YAAY;MACZ,aAAa;MACb,2CAA2C;MAC3C,yBAAyB;MACzB,mBAAmB;MACnB,uBAAuB;MACvB,mBAAmB;MACnB,sBAAsB;MACtB,YAAY;MACZ,WAAW;MACX,mBAAmB;IACrB;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,eAAe;MACf,yBAAyB;MACzB,kBAAkB;MAClB,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,aAAa;MACb;QACE,eAAe;;MAEjB;IACF;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF","sourcesContent":[".newTagHeader {\n  height: 40px;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  padding: 6px 18px;\n  /* background-color: var(--f5-background); */\n  position: sticky;\n  top: 0;\n  @media (width<=768px) {\n    padding: 6px 4px;\n  }\n  .leftSide {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    .iconContainer {\n      border: none;\n      outline: none;\n      border-radius: 6px;\n      -webkit-border-radius: 6px;\n      -moz-border-radius: 6px;\n      -ms-border-radius: 6px;\n      -o-border-radius: 6px;\n      cursor: pointer;\n      border: 1px solid transparent;\n      padding: 4px;\n      display: flex;\n      background-color: var(--_10a37f-background);\n      color: var(--white-color);\n      align-items: center;\n      justify-content: center;\n      height: fit-content;\n      box-sizing: border-box;\n      height: 25px;\n      width: 25px;\n      pointer-events: all;\n    }\n    h3 {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      font-size: 17px;\n      color: var(--black-color);\n      text-align: center;\n      font-family: Inter;\n      font-size: 19px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 130%; \n      margin: 0px 0;\n      @media (width<=768px) {\n        font-size: 15px;\n        \n      }\n    }\n  }\n\n  .rightSide {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newTagHeader": `newTagHeader_D4FE5`,
	"leftSide": `leftSide_g8nSi`,
	"iconContainer": `iconContainer_q6rdb`,
	"rightSide": `rightSide_LBM3u`
};
export default ___CSS_LOADER_EXPORT___;
